import React, { useState } from 'react';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import RMSCommonDialog from '../../dialog/RMSCommonDialog';
import { RMSButton } from '../../buttons';
import { formatDateTime } from '../../../utility/dateFormatter';

const RMSRecordHistoryButton = ({
  disabled = false,
  created = null,
  createdBy = '',
  updated = null,
  updatedBy = '',
}) => {
  const [open, setOpen] = useState(false);
  const showUpdated = Boolean(updated) && !moment(created).isSame(moment(updated));

  return (
    <>
      <RMSButton
        label="History"
        variant="contained"
        color="primary"
        prefixIcon={<HistoryIcon />}
        disabled={disabled}
        onClick={() => setOpen(true)}
      />

      <RMSCommonDialog
        open={open}
        title="Record History"
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
        saveButton={{ show: false }}
        cancelButton={{
          show: true,
          type: 'simple',
          label: 'Close',
          variant: 'outlined',
          color: 'secondary',
        }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Created By: {createdBy || '-'}</Typography>
            <Typography variant="body2" color="textSecondary">
              {formatDateTime(created) || '-'}
            </Typography>
          </Grid>

          {showUpdated && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">Updated By: {updatedBy || '-'}</Typography>
              <Typography variant="body2" color="textSecondary">
                {formatDateTime(updated) || '-'}
              </Typography>
            </Grid>
          )}
        </Grid>
      </RMSCommonDialog>
    </>
  );
};

export default RMSRecordHistoryButton;
